import {
  CurrentUserStore,
  DateUtils,
  SKZTournament,
  ClientPropertyConstants,
  SKZConstants,
} from '@sdk-mobile';
import {UserInfo, UserPersonalInfo} from '@/services/internal/user/types';
import {isPhoneRegisteredUpfront} from '@/utils/signup';

export const getMinimumAge = (
  tournament: SKZTournament,
  personalInfo: UserPersonalInfo
): number | undefined => {
  const minimumAge =
    tournament.isFriendTournament() && tournament.isPointsTournament()
      ? SKZConstants.SKZ_MINIMUM_CASH_PLAY_AGE
      : SKZConstants.SKZ_MINIMUM_FRIENDS_PLAY_AGE;

  const ageNeeded = !(
    (tournament.isPointsTournament() || tournament.isZEntryBonusCashPrizeTournament()) &&
    !tournament.isFriendTournament()
  );

  const ageWithin = DateUtils.ageWithin(personalInfo, {minimumAge});

  return ageNeeded && !ageWithin ? minimumAge : undefined;
};

export const isAccountRequired = (
  tournament: SKZTournament,
  personalInfo: UserPersonalInfo
): boolean => {
  // TODO (websdk-ms-1-phase-play): Investigate cloud gaming
  // sdk-mobile/sdk-core/js/app/Utilities/SaveAccountFlowController/SaveAccountFlowController.tsx:190

  if (!tournament.shouldRegisterBeforePlay()) {
    return false;
  }

  const cashTournament = !tournament.isPointsTournament();
  const registrationNeeded = cashTournament || tournament.isFriendTournament();

  // TODO (websdk-ms-1-phase-play): check if CurrentUserStore works,
  // if not, replace with:
  // Boolean(user?.email || (personalInfo?.phone_number && personalInfo?.phone_verified)
  const isRegistered = CurrentUserStore.isSavedAccount();

  if (isPhoneRegisteredUpfront) {
    // This condition is added for web only due to new sign in by phone only.
    // Phone is verified during account creation, so we have to check email.
    const emailIsMissing = personalInfo?.phone_verified && !personalInfo?.email;
    return registrationNeeded && (!isRegistered || emailIsMissing);
  }

  return registrationNeeded && !isRegistered;
};

export const isEmailRequired = (tournament: SKZTournament, user: UserInfo) => {
  return tournament.isFriendTournament() && !user.email_verified;
};

export const isPhoneRequired = (tournament: SKZTournament, personalInfo: UserPersonalInfo) => {
  const userShouldVerify =
    ClientPropertyConstants.getFriendsTournamentsPhoneNumber() ||
    ClientPropertyConstants.getVerifySMSGameplay();
  const userNotVerified = !personalInfo?.phone_verified;
  const friendsMatchCheck =
    tournament.isFriendTournament() && ClientPropertyConstants.getFriendsTournamentsPhoneNumber();
  const cashMatchCheck =
    tournament.isCashTournament() &&
    !tournament.isZEntryBonusCashPrizeTournament() &&
    ClientPropertyConstants.getVerifySMSGameplay();
  const isNonTournamentOrValidTournament = friendsMatchCheck || cashMatchCheck;

  return userShouldVerify && userNotVerified && isNonTournamentOrValidTournament;
};
